import {useState} from 'react';
import {Button, Card, Form} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {CIDR_REGEX} from '../../Utils/random';
import {useSetVpnSubnet} from '../../Hooks/RouterManager';
import Level3Title from '../../../../app/common/components/title/Level3Title';

interface VpnSubnetSectionProps {
  routerId: string;
  subnet: string | null;
}

const VpnSubnetSection = ({routerId, subnet}: VpnSubnetSectionProps): JSX.Element => {
  const intl = useIntl();
  const [draft, setDraft] = useState(subnet ?? '');
  const [validated, setValidated] = useState(false);
  const setSubnet = useSetVpnSubnet(routerId);

  const isValid = CIDR_REGEX.test(draft);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setValidated(true);
    if (!isValid) return;
    setSubnet.mutate(draft);
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.SUBNET_TITLE'})} />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="row g-3 align-items-end">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="required">
                  {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.SUBNET'})}
                </Form.Label>
                <Form.Control
                  type="text"
                  value={draft}
                  onChange={(e) => setDraft(e.target.value)}
                  placeholder="192.168.2.0/24"
                  isInvalid={validated && !isValid}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VALIDATION.CIDR'})}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="col-md-2">
              <Button variant="primary" type="submit">
                {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.SET_SUBNET'})}
              </Button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default VpnSubnetSection;
